import _extends from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React, { useEffect, useState } from 'react';
import { PlaceholderButton } from 'react-bootstrap';
import { useUser } from '@miro-site/core';
import { useTextTokens } from '../../providers/TextTokensProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export var SignUpButton = function SignUpButton(_ref) {
  var props = _extends({}, _ref);

  var _useState = useState(true),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useUser = useUser(),
      isLoggedIn = _useUser.isLoggedIn;

  var textTokens = useTextTokens();

  var _ref2 = textTokens || {},
      userLoggedInText = _ref2.userLoggedInText;

  useEffect(function () {
    setIsLoading(false);
  }, [isLoggedIn]);

  if (isLoading) {
    return /*#__PURE__*/_jsx(PlaceholderButton, {
      variant: "primary",
      className: "py-300 px-1200"
    });
  }

  if (isLoggedIn) {
    return /*#__PURE__*/React.cloneElement(props.children, {
      href: '/app',
      children: userLoggedInText || 'Go to the dashboard'
    });
  }

  return props.children;
};